import React, { PropTypes } from 'react';
import { connect } from 'react-redux';

import Container from './Container';
import SearchView from './SearchView';
import StartView from './StartView';
import MapView from './MapView';

const App = () => (
    <Container>
        <StartView />
        <SearchView />
        <MapView />
    </Container>
)

export default App;


// WEBPACK FOOTER //
// ./containers/App.js